import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

import { PrimeNGConfig } from 'primeng/api';
import { filter } from 'rxjs/operators';
import {
  ConfigService,
  TokenService,
  UserService,
} from 'viggo-sistemas-core-web';

declare const gtag: Function; // <TODO: DECLARAÇÃO DA FUNÇÃO QUE IRÁ INTERCEPTAR DUPLICIDADE DE EVENTOS!

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  enLanguage = {
    primeng: {
      dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      dateFormat: 'dd/mm/yy',
      firstDayOfWeek: 0,
      today: 'Hoje',
    },
  };

  public readonly appName = 'Viggo-Gestor';
  botViggoElement: HTMLScriptElement;
  loadingDataImg = false;

  public constructor(
    protected userService: UserService,
    protected tokenService: TokenService,
    protected configService: ConfigService,
    private config: PrimeNGConfig,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    localStorage.setItem('URL_API', configService.backendURL);
    // TODO: BOT DO SUPORTE DA VIGGO
    // ADICIONE ESSA CONFIG NO ANGULAR.JSON QUE AI REATIVA O BOT
    // "scripts": [
    //   "src/assets/bot_viggo.js"
    // ],
    // this.botViggoElement = document.createElement('script');
    // this.botViggoElement.src = 'src/assets/bot_viggo.js';
    // document.body.appendChild(this.botViggoElement);

    router.events.subscribe((event) => {
      this.navigationInterceptor(event);
    });

    // TODO: Quando o usuário navega para outro componente pela rota,
    // precisamos interceptar a requisição da seguinte forma
    /** START : Code to Track Page View using gtag.js */
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.sendEventosToAnalytics(event);
      });
    /** END : Code to Track Page View  using gtag.js */

    // Add dynamic title for selected pages - Start
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(
          router.routerState,
          router.routerState.root,
        ).join(' > ');
        titleService.setTitle(title);
      }
    });
    // Add dynamic title for selected pages - End
  }

  /**
   * Função responsável por tratar os eventos e parametros enviados pro analytics
   * @param event
   */
  sendEventosToAnalytics(event: NavigationEnd) {
    if (
      gtag &&
      !(
        event.urlAfterRedirects.includes('workspace') ||
        event.urlAfterRedirects.includes('auth/login')
      ) &&
      !this.configService.frontendURL.includes('homo') &&
      !this.configService.frontendURL.includes('localhost')
    )
      gtag('event', 'page_view', {
        page_path: event.urlAfterRedirects,
        page_title: this.getPageTitle(event.urlAfterRedirects),
        app_name: this.appName,
        dimension: `${window.screen.width}X${window.screen.height}`,
        domain_id: this.tokenService.getDomain()
          ? this.tokenService.getDomain().id
          : 'Não logado',
        browser: this.getIdBrowser(),
      });
  }

  /**
   * Identifica exatamente em qual página web o usuário acessou
   * @param url
   * @returns
   */
  getPageTitle(url: string) {
    var path_ = url.substring(url.indexOf('/') + 1, url.lastIndexOf('/'));
    if (url.includes('dados-empresa/editar'))
      return `Viggo-Gestor: Alteração na empresa`;
    if (url.includes('dados-empresa/settings'))
      return `Viggo-Gestor: Alteração nas regras de negócio da empresa`;
    if (url.includes('dados-fiscais/editar-fiscal'))
      return `Viggo-Gestor: Alteração nos dados fiscais da empresa`;
    if (url.includes('dados-fiscais/settings-fiscal'))
      return `Viggo-Gestor: Alteração nas configurações fiscais da empresa`;
    if (url.includes('new')) return `Viggo-Gestor: Criação de ${path_}`;
    if (url.includes('edit')) return `Viggo-Gestor: Alteração em ${path_}`;
    if (url.includes('landing')) {
      var path_ = url.substring(url.lastIndexOf('/') + 1);
      return `Viggo-Gestor: Possível novo registro na landing - ${path_.toUpperCase()}`;
    }
  }

  /**
   * Idenfitica o navegador utilizado
   * @returns
   */
  getIdBrowser() {
    const ua = navigator.userAgent;
    let tem;
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
      ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return `IE ${tem[1] || ''}`;
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  }

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: any): void {
    // Triggered When the navigation starts
    if (event instanceof NavigationStart) {
      this.loadingDataImg = true;
    }
    // Triggered When the navigation ends
    if (event instanceof NavigationEnd) {
      this.loadingDataImg = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loadingDataImg = false;
    }
    // Triggered When the error occurrs while navigation
    if (event instanceof NavigationError) {
      this.loadingDataImg = false;
    }
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
    this.config.ripple = true;

    this.config.setTranslation(this.enLanguage.primeng);

    this.donwloadUserImage();

    this.tokenService.onLoggedIn$.subscribe(() => {
      this.donwloadUserImage();
    });
  }

  private donwloadUserImage(): void {
    const user = this.tokenService.getUser();
    if (user && user.photo_id)
      this.userService
        .donwloadUserImage(user.photo_id)
        .subscribe((result) => this.tokenService.setUserImage(result));
  }
}
